import { BBDTag, Texto } from '@gravitate-js/excalibrr'

export function ConfigStatusCell({ value }: { value: string }) {
  return <BBDTag warning={value === 'Custom'}>{value}</BBDTag>
}
